import { Button, Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { ChallengeTypeEnum } from 'src/shared/enums';
import { checkUserResourcePoints } from 'utils';

interface OwnProps {
  challengeType: ChallengeTypeEnum;
  checkoutPoints: number;
  image: string;
  performCheckout: () => void;
  termsLabel: string;
  termsUrl: string;
  text: string;
  title: string;
  userPoints: number;
  loading: boolean;
}

export default function CheckoutDonationDetails({
  challengeType,
  checkoutPoints,
  image,
  performCheckout,
  termsLabel,
  termsUrl,
  text,
  title,
  userPoints,
  loading,
}: OwnProps) {
  const { formatMessage } = useIntl();
  const [termsAccepted, setTermsAccepted] = useState(false);

  const hasUserEnoughPoints = checkUserResourcePoints(
    userPoints,
    checkoutPoints,
    challengeType
  );
  const pointsLabel = Math.abs(checkoutPoints);

  const handleCheck = (ev: CheckboxChangeEvent) => {
    setTermsAccepted(ev.target.checked);
  };

  const buttonContent = (
    <>
      <Checkbox
        checked={termsAccepted}
        className="checkbox-remember-login"
        onChange={handleCheck}
      >
        <span className="checkout-product__terms--content">
          {formatMessage({
            id: 'page.experience.checkout.summary-terms',
          })}
          <a
            target="_blank"
            rel="noreferrer"
            href={termsUrl}
            className="link underline-text"
          >
            {termsLabel}
          </a>
        </span>
      </Checkbox>

      <Button
        id="checkout-donation-modal-send"
        className="btn-primary btn-primary--black btn-primary__small checkout-modal-send button--spacing"
        disabled={!termsAccepted || !hasUserEnoughPoints}
        onClick={performCheckout}
        loading={loading}
      >
        {formatMessage(
          { id: 'page.experience.checkout.button' },
          { points: pointsLabel }
        )}
      </Button>
    </>
  );

  return (
    <div className="checkout-modal-details experience-checkout-lottery__detail">
      <div className="checkout-product__title not_show_on_desktop checkout-modal-details">
        {formatMessage({
          id: 'page.experience.checkout.summary-label-donation',
        })}
      </div>
      <div className="rounded-card checkout-product">
        <div className="checkout-product__header">
          <div className="checkout-product__header--image">
            <img alt="product" src={image} />
          </div>
          <span className="checkout-product__header--product-name">
            {title}
          </span>
          <span className="checkout-product__header--points">
            {formatMessage(
              { id: 'page.experience.checkout.summary-points' },
              { points: pointsLabel }
            )}
          </span>
        </div>

        <div className="card__second-row">
          <div>&nbsp;</div>
          <div className="checkout-product__description--content">{text}</div>
        </div>
      </div>

      <div className="not_show_on_breakpoint-md experience-checkout-lottery__detail__button__wrapper">
        {buttonContent}
      </div>
      <div className="show_on_breakpoint-md experience-checkout-button__wrapper experience-checkout-button__wrapper--shadow">
        {buttonContent}
      </div>
    </div>
  );
}
